import { createContext, useContext, useReducer  } from 'react'

const ReadyContext = createContext()

const useReady = () => {
    const context = useContext(ReadyContext)

    if (context === undefined) throw new Error('useReady must be used within a ReadyProvider')

    return context
}

const ReadyProvider = ({ children }) => {
    const reducer = (state, { name, status }) => {
        return { ...state, [name]: status }
    }

    const [$state, dispatch] = useReducer(reducer, {})

    const set = (name, status = true) => dispatch({ name, status })

    return (
        <ReadyContext.Provider value={{ $state, set }}>
            {children}
        </ReadyContext.Provider>
    )
}

export { useReady, ReadyProvider }